import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HiChevronRight, HiHome } from 'react-icons/hi';

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // Custom route names mapping
  const routeNames: { [key: string]: string } = {
    'ai-agents': 'AI Agents',
    'face-recognition': 'Face Recognition',
    'ocr': 'OCR',
    'object-detection': 'Object Detection',
    'text-summarization': 'Text Summarization',
    'language-translation': 'Language Translation',
    'sentiment-analysis': 'Sentiment Analysis',
    'chatbots': 'Chatbots',
    'recommendation-systems': 'Recommendation Systems',
    'time-series-forecasting': 'Time Series Forecasting',
  };

  return (
    <nav className="flex items-center space-x-1 text-sm text-gray-400 px-6 py-3">
      <Link
        to="/"
        className="flex items-center hover:text-white transition-colors"
      >
        <HiHome className="w-4 h-4" />
      </Link>

      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        const displayName = routeNames[name] || name.charAt(0).toUpperCase() + name.slice(1);

        return (
          <React.Fragment key={name}>
            <HiChevronRight className="w-4 h-4 text-gray-600" />
            <Link
              to={routeTo}
              className={`
                whitespace-nowrap hover:text-white transition-colors
                ${isLast ? 'text-white pointer-events-none' : ''}
              `}
            >
              {displayName}
            </Link>
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;


// import React from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { HiChevronRight, HiHome } from 'react-icons/hi';

// const Breadcrumbs = () => {
//   const location = useLocation();
//   const pathnames = location.pathname.split('/').filter((x) => x);

//   return (
//     <nav className="flex items-center space-x-1 text-sm text-gray-400 px-4 py-2">
//       <Link
//         to="/"
//         className="flex items-center hover:text-white transition-colors"
//       >
//         <HiHome className="w-4 h-4" />
//       </Link>

//       {pathnames.map((name, index) => {
//         const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
//         const isLast = index === pathnames.length - 1;

//         return (
//           <React.Fragment key={name}>
//             <HiChevronRight className="w-4 h-4 text-gray-600" />
//             <Link
//               to={routeTo}
//               className={`
//                 capitalize hover:text-white transition-colors
//                 ${isLast ? 'text-white pointer-events-none' : ''}
//               `}
//             >
//               {name.replace(/-/g, ' ')}
//             </Link>
//           </React.Fragment>
//         );
//       })}
//     </nav>
//   );
// };

// export default Breadcrumbs;